import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dti-calculator',
  component: () => import('../../routes/DtiCalculator.svelte'),
  card: {
    id: 'dti-calculator',
    title: 'Debt-to-Income Ratio',
    description: 'Calculate your DTI ratio and see how lenders evaluate your debt load.',
    icon: 'balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/dti-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Debt-to-Income Ratio Calculator – Free DTI Calculator',
    description: 'Free debt-to-income ratio calculator. Calculate your front-end and back-end DTI ratios, see lender thresholds, and find out how much additional borrowing capacity you have. Includes the 28/36 rule and 43% QM limit.',
  },
};

export default meta;
